import { useState } from 'react';
import { isYouTubeUrl, getYouTubeThumbnail } from '@shared/utils/videoUtils';

const ACCENT = { borderLeft: '6px solid #BC313D', paddingLeft: 20 };

const INITIAL = 6;
const STEP = 4;

const VideoCard = ({ item, onClick }) => {
  const isYT = item.videoUrl && isYouTubeUrl(item.videoUrl);
  const effectiveThumbnail = item.thumbnailUrl || (isYT ? getYouTubeThumbnail(item.videoUrl) : null);
  return (
    <div
      className="cursor-pointer group"
      style={{ width: '100%' }}
      onClick={() => item.videoUrl && onClick()}
    >
      <div style={{ width: '100%', aspectRatio: '1', position: 'relative', background: '#FAF7F3', boxShadow: '2px 4px 8px rgba(110,98,91,0.08)', overflow: 'hidden' }}>
        {effectiveThumbnail ? (
          <img src={effectiveThumbnail} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : item.videoUrl ? (
          <video src={`${item.videoUrl}#t=0.1`} preload="metadata" muted playsInline controlsList="nodownload" onContextMenu={(e) => e.preventDefault()} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(188,49,61,0.08)' }} />
        )}
        <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, padding: 12, background: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.35) 100%)' }}>
          {item.videoUrl && (
            <span className="material-symbols-outlined" style={{ color: 'rgba(255,255,255,0.9)', fontSize: 32 }}>play_arrow</span>
          )}
          <p className="line-clamp-2 text-center" style={{ fontFamily: 'Noto Serif TC', fontSize: 14, fontWeight: 700, color: '#FFFFFF', letterSpacing: '0.05em', textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>
            {item.title}
          </p>
        </div>
      </div>
    </div>
  );
};

/**
 * 影片集分類區塊：相簿式 grid（手機 2 欄、桌機 auto-fill），標題顯示於縮圖上方，點擊「查看更多」可展開／收合
 */
const VideoCategorySection = ({ titleBlack, titleRed, items, onSelect, isFirst, isLast, viewMoreText, collapseText }) => {
  const [visible, setVisible] = useState(INITIAL);
  const [sectionOpen, setSectionOpen] = useState(true);
  const hasMore = visible < items.length;
  const expanded = visible > INITIAL;

  const handleToggle = () => {
    if (hasMore) {
      setVisible((v) => v + STEP);
    } else {
      setVisible(INITIAL);
    }
  };

  if (items.length === 0) return null;

  return (
    <section className={`px-6 ${isLast ? 'pb-10' : ''}`}>
      <div className={isFirst ? 'h-6' : 'h-6 pt-6'} />

      <div style={{ ...ACCENT, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
        <h2 style={{ fontFamily: 'Noto Serif TC', fontSize: 30, fontWeight: 700, lineHeight: '33px' }}>
          <span style={{ color: '#171717' }}>{titleBlack}</span><br />
          <span style={{ color: '#BC313D' }}>{titleRed}</span>
        </h2>
        <button
          onClick={() => setSectionOpen((v) => !v)}
          aria-expanded={sectionOpen}
          aria-label={sectionOpen ? collapseText : viewMoreText}
          style={{ flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', color: '#BC313D', display: 'flex', alignItems: 'center' }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 28, transform: sectionOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>expand_more</span>
        </button>
      </div>

      {sectionOpen && (
      <div style={{ paddingTop: 12, paddingBottom: 8 }}>
        <div
          className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5"
          style={{ gap: 8 }}
        >
          {items.slice(0, visible).map((item) => (
            <VideoCard key={item.id} item={item} onClick={() => onSelect(item)} />
          ))}
        </div>

        {(hasMore || expanded) && items.length > INITIAL && (
          <div className="flex justify-center pt-3 pb-2">
            <button
              onClick={handleToggle}
              style={{ color: '#BC313D', fontSize: 16, fontFamily: 'Noto Serif TC', fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
            >
              {hasMore ? viewMoreText : collapseText}
              <span className="material-symbols-outlined text-base" style={{ transform: !hasMore ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>expand_more</span>
            </button>
          </div>
        )}
      </div>
      )}
    </section>
  );
};

export default VideoCategorySection;
